//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      list: [{
          icon: 'icon-questions',
          title: '常见问题',
          childList: [{
            title: '单词斩如何开通会员？',
            content: '请点击[我的] - [添加微信] 识别商家微信添加进行咨询开通'
          }, {
            title: '单词斩如何联系商家？',
            content: '请点击[我的] - [添加微信] 添加进行联系'
          }, {
            title: '单词斩官网地址多少？',
            content: 'http://单词斩.vip'
          }, {
            title: '单词斩文档地址多少？',
            content: 'http://doc.单词斩.vip'
          }]
        },
        {
          icon: 'icon-others',
          title: '其他问题',
          childList: [{
            title: '如何退出登录？',
            content: '请点击[我的] - [应用设置] - [退出登录]即可退出登录',
          }, {
            title: '如何修改用户头像？',
            content: '请点击[我的] - [选择头像] - [点击提交]即可更换用户头像',
          }, {
            title: '如何修改登录密码？',
            content: '请点击[我的] - [应用设置] - [修改密码]即可修改登录密码',
          }]
        }
      ]
    }
  },
  methods: {
    handleText(item) {
      this.$router.push({ path: `wtlb_display?title=${item.title}&content=${item.content}` });
    },  goBack: function () {
    },
    goReturn() {
      this.$router.push({ path: "mine?hideTrans=true" });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/publicView/me/cjwt.vue